// "Quantos abastecimentos usaram este desconto": o texto do cartão da lista. Funções puras.
//
// GET /discount-usage (filter.ids, até 50) devolve por desconto `fillins` (null = não sabe), a janela que contou
// (`last30d` = últimos 30 dias, para o que vale agora; `period` = o período todo, para o que já acabou) e as datas.
import { __t } from '../../../i18n/t'
import { DiscountStatusKey, fmtN } from './discountStatus'

export enum UsageWindow {
  last30d = 'last30d',
  period = 'period',
}

export interface DiscountUsage {
  id: string
  fillins: number | null
  window: string
  from?: string | null
  to?: string | null
}

/** Resposta do GET /discount-usage -> mapa por id do desconto. Linha sem id ou fora do formato é ignorada. */
export const toUsageMap = (res: unknown): Map<string, DiscountUsage> => {
  const rows = (res as { data?: unknown } | null | undefined)?.data
  const map = new Map<string, DiscountUsage>()
  if (!Array.isArray(rows)) return map
  rows.forEach(row => {
    if (!row || typeof row !== 'object' || !(row as DiscountUsage).id) return
    const r = row as DiscountUsage
    const n = r.fillins == null ? null : Number(r.fillins)
    map.set(String(r.id), { ...r, id: String(r.id), fillins: n != null && Number.isFinite(n) && n >= 0 ? n : null })
  })
  return map
}

/** Vazio quando não há número (a conta falhou) ou quando o desconto ainda nem começou e naturalmente tem zero. */
export const usageText = (usage: DiscountUsage | undefined, status: DiscountStatusKey): string => {
  if (!usage || usage.fillins == null) return ''
  const n = usage.fillins
  if (status === DiscountStatusKey.scheduled && n === 0) return ''
  if (usage.window === UsageWindow.last30d) {
    if (n === 0) return __t('Nenhum abastecimento nos últimos 30 dias')
    return n === 1 ? __t('1 abastecimento nos últimos 30 dias') : __t('%{n} abastecimentos nos últimos 30 dias', { n: fmtN(n) })
  }
  if (usage.window === UsageWindow.period) {
    if (n === 0) return __t('Nenhum abastecimento no período')
    return n === 1 ? __t('1 abastecimento no período') : __t('%{n} abastecimentos no período', { n: fmtN(n) })
  }
  return ''
}
